import { render } from "./TextSlider.vue?vue&type=template&id=025e60eb"
import script from "./TextSlider.vue?vue&type=script&lang=js"
export * from "./TextSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__